import React, { useState } from 'react';

import "./App.css";
import Filter from './Filter';
import UserTable from "./UserTable.jsx";
import LoginForm from './LoginForm';

const App = () => {
  const [currentFilter, setCurrentFilter] = useState('');
  const [loggedInUser, setLoggedInUser] = useState(null);

  const BASE_URL = "https://datarevolution.cl/backend/getUsers";
  const PAGE_SIZE = 10;

  const applyFilter = (filterString) => {
    setCurrentFilter(filterString);
    // Aquí iría tu lógica para actualizar resultados
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      {!loggedInUser ? (
        <LoginForm onLogin={(user) => setLoggedInUser(user)} />
      ) : (
        <>
          <div className="mb-6 text-right text-sm text-gray-600">
            Sesión iniciada como: <strong>{loggedInUser}</strong>
          </div>
          <Filter onApply={applyFilter} />
          <UserTable BASE_URL={BASE_URL} currentFilter={currentFilter} pageSize={PAGE_SIZE} />
          <p className="mt-4 text-sm text-gray-500">
            endpoint={BASE_URL + "?" + currentFilter} pageSize={PAGE_SIZE} numberOfPages={1194}
          </p>
        </>
      )}
    </div>
  );
};

export default App;
